enum BusinessStatus {
  PreOpen = 'PreOpen',
  Open = 'Open',
  Remodel = 'Remodel',
  Closed = 'Closed',
}

export default BusinessStatus;
